/* eslint-disable */
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import DashIcon from "components/icons/DashIcon";
import { FaAngleDown, FaAngleRight } from "react-icons/fa";
import { IoEllipse } from "react-icons/io5";
import { useSelector } from "react-redux";
// chakra imports

export default function SidebarLinks(props) {
  const [subelementosview, setSubelementosview] = useState({ view: false, target: "" });
  const { userToken, user } = useSelector((state) => state.userReducer);
  const location = useLocation();
  const { routes } = props;

  const currentRouteSegment = location.pathname.split("/").filter(Boolean).pop();

  useEffect(() => {
    routes.forEach((route) => {
      route.elementos.forEach((route2) => {
        if (route2.desplegable) {
          route2.subelementos.forEach((route3) => {
            if (location.pathname === route3.path) {
              setSubelementosview({ view: true, target: route2.name });
            }
          });
        }
      });
    });
  }, [routes, location.pathname]);

  const createLinks = (routes) => {
    return routes.map((route, index) => {
      if (route.hide) return null;

      const isSectorVisible = userToken && route.autoridad.includes(user.autoridad);
      return (
        <div key={index}>
          {isSectorVisible && (
            <div className="my-[5px] flex cursor-pointer items-center px-8 uppercase opacity-50">
              {route.sector}
            </div>
          )}

          {route.elementos.map((route2, key2) => {
            const isDesplegable = route2.desplegable;
            const isRouteActive = currentRouteSegment === route2.path;
            const isSubOpen = subelementosview.view && subelementosview.target === route2.name;
            const altura = `h-[${route2.subelementos.length * 50}px]`;

            const isVisible = userToken && route2.autoridad.includes(user.autoridad);
            if (!isVisible) return null;

            const commonRouteProps = {
              className: `my-[3px] flex cursor-pointer items-center px-8`,
              key: key2,
            };

            if (isDesplegable) {
              return (
                <div key={key2}>
                  <div
                    onClick={() =>
                      setSubelementosview({
                        view: isSubOpen ? false : true,
                        target: route2.name,
                      })
                    }
                    className="relative flex hover:cursor-pointer h-12"
                  >
                    <li {...commonRouteProps}>
                      <span className={isRouteActive ? "font-bold text-brand-500 dark:text-white" : "font-medium text-gray-700"}>
                        {route2.icon ?? <IoEllipse size={14} />}
                      </span>
                      <p className={`leading-1 ml-4 flex items-center ${isRouteActive ? "font-bold text-navy-700 dark:text-white" : "font-medium text-gray-700"}`}>
                        {route2.name}
                        <FaAngleRight
                          size={16}
                          className={`absolute right-4 transition ease-in-out duration-700 ${isSubOpen ? "rotate-90" : ""
                            }`}
                        />
                      </p>
                    </li>
                    {isRouteActive && (
                      <div className="absolute right-0 h-12 w-1 rounded-lg bg-brand-500 dark:bg-brand-400" />
                    )}
                  </div>

                  <div
                    className={`transition-[max-height] duration-500 ease-in-out overflow-hidden`}
                    style={{
                      maxHeight: isSubOpen ? `${route2.subelementos.length * 48}px` : "0px",
                    }}
                  >
                    {route2.subelementos.map((route3, key3) => {
                      const isSubActive = currentRouteSegment === route3.path;
                      const isSubVisible = userToken && route3.autoridad.includes(user.autoridad);
                      if (!isSubVisible) return null;

                      return (
                        <div key={key3} className={`ml-2 ${isSubActive && "bg-lightPrimary dark:bg-navy-700 h-12 rounded-lg"}`}>
                          <Link to={route3.layout + "/" + route3.path}>
                            <div className="relative flex items-center hover:cursor-pointer h-12">
                              <li className="my-[3px] flex cursor-pointer items-center px-8">
                                <span className={isSubActive ? "font-bold text-brand-500 dark:text-white" : "font-medium text-gray-700"}>
                                  {route3.icon ?? <IoEllipse size={14} />}
                                </span>
                                <p className={`leading-1 ml-4 flex ${isSubActive ? "font-bold text-navy-700 dark:text-white" : "font-medium text-gray-700"}`}>
                                  {route3.name}
                                </p>
                              </li>
                              {isSubActive && (
                                <div className="absolute right-0 h-12 w-1 rounded-lg bg-brand-500 dark:bg-brand-400" />
                              )}
                            </div>
                          </Link>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            }

            // No desplegable
            return (
              <div key={key2} className={`ml-5 ${isRouteActive && "bg-lightPrimary dark:bg-navy-700 h-12 rounded-lg"}`}>
                <Link to={route2.layout + "/" + route2.path}>
                  <div className="relative flex items-center hover:cursor-pointer h-12">
                    <li className="my-[3px] flex cursor-pointer items-center px-3">
                      <span className={isRouteActive ? "font-bold text-brand-500 dark:text-white" : "font-medium text-gray-700"}>
                        {route2.icon ?? <IoEllipse size={14} />}
                      </span>
                      <p className={`leading-1 ml-4 flex ${isRouteActive ? "font-bold text-navy-700 dark:text-white" : "font-medium text-gray-700"}`}>
                        {route2.name}
                      </p>
                    </li>
                    {isRouteActive && (
                      <div className="absolute right-0 h-12 w-1 rounded-lg bg-brand-500 dark:bg-brand-400" />
                    )}
                  </div>
                </Link>
              </div>
            );
          })}
        </div>
      );
    });
  };

  return createLinks(routes);
}
